var $14806b536573f664$exports = {};
$14806b536573f664$exports = {
    "collapse": `Reduzieren`,
    "expand": `Erweitern`
};


export {$14806b536573f664$exports as default};
//# sourceMappingURL=de-DE.mjs.map
